import { type FC } from 'react';

import { Picture } from '@/components/ui/Picture/Picture';

import css from './styles.module.scss';

import starsPatternPng from '/img/dice-game/stars-pattern.png';
import starsPatternWebp from '/img/dice-game/stars-pattern.webp';

const BingoBackground: FC = () => {
  return (
    <div className={css.bg}>
      <div className="relative w-full h-full">
        <div className={css.ellipse} />
        <Picture
          className="absolute w-full aspect-[444/443] left-1/2 top-0 -translate-x-1/2"
          img={starsPatternPng}
          webp={starsPatternWebp}
          alt=""
        />
        <div className={css.radialBg} />
      </div>
    </div>
  );
};

export { BingoBackground };
